import { render, staticRenderFns } from "./AirticketyudingshenqingRight.vue?vue&type=template&id=3a5a3b61&scoped=true"
import script from "./AirticketyudingshenqingRight.vue?vue&type=script&lang=js"
export * from "./AirticketyudingshenqingRight.vue?vue&type=script&lang=js"
import style0 from "./AirticketyudingshenqingRight.vue?vue&type=style&index=0&id=3a5a3b61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5a3b61",
  null
  
)

export default component.exports